/* ==========================================================================
   BELORA — SKIMS PURE · yorumlar
   The first five real reviews are painted server-side
   (snippets/sk-reviews-seed.liquid), and so is the filter panel
   (snippets/sk-reviews-filters.liquid). This file only:
     - opens and closes the filter panel,
     - filters the dataset the way the reference's panel does — within a group
       any chosen value matches, across groups every group must match,
     - pages five more at a time ("Daha Fazla"),
     - writes each new card's age the same way sk-rel-date.liquid does.
   Nothing is produced here: every field comes from
   `belora-reviews.generated.json`, and a field that is empty there is not
   drawn. The dataset is fetched once, on the first action that needs it.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-sk-reviews]');
  if (!root) return;

  var list = root.querySelector('[data-sk-review-list]');
  var moreBtn = root.querySelector('[data-sk-review-load]');
  var errorBox = root.querySelector('[data-sk-review-error]');
  var emptyBox = root.querySelector('[data-sk-review-empty]');
  var status = root.querySelector('[data-sk-review-status]');
  var toggle = root.querySelector('[data-sk-rf-toggle]');
  var panel = root.querySelector('[data-sk-rf-panel]');
  var handle = root.getAttribute('data-handle');
  var jsonUrl = root.getAttribute('data-json');
  var PAGE = 5;

  var all = null;             // the whole dataset for this product, once fetched
  var view = null;            // the reviews the current filters let through
  var shown = parseInt(root.getAttribute('data-seeded'), 10) || PAGE;
  var pending = null;

  // Star markup comes from what the server painted, so the two cannot drift.
  var STAR = (function () { var s = root.querySelector('.sk-review__stars svg'); return s ? s.outerHTML : ''; })();
  var THUMB = '<svg class="sk-review__thumb" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path d="M4.5 7v7H2.5a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h2Zm1 7V7l2.7-4.6a1 1 0 0 1 1.8.7L9.5 6h3.7a1.3 1.3 0 0 1 1.28 1.55l-1.1 5.4A1.3 1.3 0 0 1 12.1 14H5.5Z" fill="currentColor"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Same wording and thresholds as snippets/sk-rel-date.liquid. */
  function age(iso) {
    var t = Date.parse(String(iso) + 'T00:00:00Z');
    if (isNaN(t)) return '';
    var days = Math.floor((Date.now() - t) / 86400000);
    if (days < 1) return 'bugün';
    if (days < 7) return days + ' gün önce';
    if (days < 30) return Math.floor(days / 7) + ' hafta önce';
    if (days < 365) return Math.floor(days / 30) + ' ay önce';
    return Math.floor(days / 365) + ' yıl önce';
  }

  // Buckets shared with scripts/build-sk-reviews.mjs.
  var VALUE = {
    rating: function (r) { return String(Number(r.rating) || ''); },
    size: function (r) { return r.purchased_size || ''; },
    height: function (r) { return r.height_cm ? String(Math.floor(Number(r.height_cm) / 5) * 5) : ''; },
    weight: function (r) { return r.weight_kg ? String(Math.floor(Number(r.weight_kg) / 10) * 10) : ''; },
  };

  var RX_END = /[.!?\u2026)\]"\u00bb]\s*$/;
  var RX_TAIL = /\s+\S*$/;
  var RX_PUNCT = /[,;:\-\u2013\u2014]\s*$/;
  var ELLIPSIS = '\u2026';

  /* Order and truncation repair, matching scripts/build-sk-reviews.mjs rule for
     rule. The server painted the first five of THIS ordering, so the ordering
     has to be reapplied here before paging or "Daha Fazla" would repeat them. */
  function completeness(r) {
    var n = (r.purchased_size ? 1 : 0) + (r.height_cm ? 1 : 0) + (r.weight_kg ? 1 : 0);
    var named = (r.name && String(r.name).trim()) ? 0 : 1;
    return (n === 3 ? 0 : (n > 0 ? 2 : 4)) + named;
  }
  function orderReviews(rs) {
    return rs.slice().sort(function (a, b) {
      return completeness(a) - completeness(b)
        || (Number(b.helpful) || 0) - (Number(a.helpful) || 0)
        || String(b.date || '').localeCompare(String(a.date || ''))
        || String(a.id || '').localeCompare(String(b.id || ''));
    });
  }
  var PHOTO_LABEL = 'M\u00fc\u015fterinin y\u00fckledi\u011fi foto\u011fraf \u2014 b\u00fcy\u00fctmek i\u00e7in t\u0131klay\u0131n';
  var CAP = 160;
  function soften(x) {
    var s = String(x || '');
    if (s.length < CAP) return s;
    if (RX_END.test(s)) return s;
    var cut = s.replace(RX_TAIL, '').replace(RX_PUNCT, '');
    return (cut.length > 40 ? cut : s.trim()) + ELLIPSIS;
  }

  function card(r) {
    var attrs = [];
    if (r.purchased_size) attrs.push(['Alınan Beden', r.purchased_size]);
    if (r.height_cm) attrs.push(['Boy', r.height_cm + ' cm']);
    if (r.weight_kg) attrs.push(['Kilo', r.weight_kg + ' kg']);
    var n = Number(r.rating) || 0;
    var stars = '';
    for (var i = 0; i < 5; i++) stars += i < n ? STAR : STAR.replace('<svg', '<svg style="opacity:.4"');
    var paras = soften(r.text).split(/\n+/).map(function (t) { return t.trim(); }).filter(Boolean);
    var helpful = Number(r.helpful) || 0;
    /* Same rule as the generator: drawn only when the record really has one. */
    var title = String(r.title || '').trim();
    var photo = String(r.image_url || '').trim();

    var li = document.createElement('li');
    li.className = 'sk-review';
    li.innerHTML =
      (String(r.name || '').trim() ? '<p class="sk-review__who"><strong class="sk-review__name">' + esc(r.name) + '</strong></p>' : '') +
      (r.date ? '<time class="sk-review__date" datetime="' + esc(r.date) + '">' + age(r.date) + '</time>' : '') +
      '<span class="sk-review__stars" role="img" aria-label="5 üzerinden ' + n + ' puan">' + stars + '</span>' +
      (attrs.length ? '<dl class="sk-review__attrs">' + attrs.map(function (a) {
        return '<div class="sk-review__attr"><dt>' + esc(a[0]) + '</dt><dd>' + esc(a[1]) + '</dd></div>';
      }).join('') + '</dl>' : '') +
      (title ? '<p class="sk-review__title">' + esc(title) + '</p>' : '') +
      (photo ? '<button type="button" class="sk-review__photo" data-sk-revphoto data-full="' + esc(photo) + '" data-alt="' + esc(r.image_alt || '') + '" aria-label="' + esc(PHOTO_LABEL) + '"><img src="' + esc(photo) + '" alt="' + esc(r.image_alt || '') + '" width="64" height="64" loading="lazy"></button>' : '') +
      '<div class="sk-review__text">' + paras.map(function (t) { return '<p>' + esc(t) + '</p>'; }).join('') + '</div>' +
      (helpful > 0 ? '<p class="sk-review__helpful" aria-label="' + helpful + ' kişi bu yorumu faydalı buldu">' + THUMB + '<span>' + helpful + '</span></p>' : '');
    return li;
  }

  function load() {
    if (all) return Promise.resolve(all);
    if (pending) return pending;
    pending = fetch(jsonUrl, { credentials: 'omit' })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (data) {
        var entry = data && data.products && data.products[handle];
        if (!entry || !entry.reviews) throw new Error('no reviews for ' + handle);
        all = orderReviews(entry.reviews);
        return all;
      });
    pending.catch(function () { pending = null; });
    return pending;
  }

  function busy(on) {
    list.setAttribute('aria-busy', on ? 'true' : 'false');
    if (moreBtn) {
      moreBtn.disabled = on;
      if (on) moreBtn.setAttribute('aria-busy', 'true'); else moreBtn.removeAttribute('aria-busy');
    }
  }
  function fail() {
    busy(false);
    if (errorBox) errorBox.hidden = false;
  }

  function appendPage() {
    var slice = view.slice(shown, shown + PAGE);
    var frag = document.createDocumentFragment();
    slice.forEach(function (r) { frag.appendChild(card(r)); });
    list.appendChild(frag);
    shown += slice.length;
    if (moreBtn) moreBtn.hidden = shown >= view.length;
  }

  /* ------------------------------------------------------- filters ----- */
  function chosen() {
    var sel = {};
    Array.prototype.forEach.call(panel.querySelectorAll('[data-rf-value][aria-pressed="true"]'), function (b) {
      var g = b.getAttribute('data-rf-group');
      (sel[g] = sel[g] || []).push(b.getAttribute('data-rf-value'));
    });
    return sel;
  }
  function passes(r, sel) {
    for (var g in sel) {
      if (!VALUE[g]) continue;
      if (sel[g].indexOf(VALUE[g](r)) < 0) return false;
    }
    return true;
  }
  function paintClears() {
    Array.prototype.forEach.call(panel.querySelectorAll('[data-rf-clear]'), function (c) {
      var g = c.getAttribute('data-rf-clear');
      c.hidden = !panel.querySelector('[data-rf-group="' + g + '"][aria-pressed="true"]');
    });
  }

  var runId = 0;
  function apply() {
    var sel = chosen();
    var id = ++runId;
    if (errorBox) errorBox.hidden = true;
    busy(true);
    load().then(function (reviews) {
      if (id !== runId) return;                       // a newer choice has already run
      view = reviews.filter(function (r) { return passes(r, sel); });
      list.innerHTML = '';
      shown = 0;
      appendPage();
      busy(false);
      if (emptyBox) emptyBox.hidden = view.length > 0;
      if (status) status.textContent = view.length + ' yorum gösteriliyor';
    }).catch(fail);
  }

  /* The panel slides the way the reference's does (QA4 motion-probe, 13 Sep 2026): its height runs 0 → full in ~185 ms,
     decelerating, and back to 0 in ~185 ms, easing at both ends. The reference's first open also waits ~750 ms for its
     data; that is latency, not motion, and is not copied. clip-path (not overflow) hides the content during the slide,
     so the first group's top margin keeps collapsing exactly as at rest and nothing jumps when the slide ends. A second
     click mid-slide turns it around from the height it has reached; a cancelled slide never runs its cleanup. */
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var slide = null;
  function slidePanel(open) {
    var from = panel.hidden ? 0 : panel.getBoundingClientRect().height;
    if (slide) { var old = slide; slide = null; old.onfinish = null; old.cancel(); }
    panel.hidden = false;
    var to = open ? panel.getBoundingClientRect().height : 0;
    if ((reduceMotion && reduceMotion.matches) || !panel.animate) {
      panel.hidden = !open;
      return;
    }
    panel.style.clipPath = 'inset(0)';
    var anim = panel.animate([{ height: from + 'px' }, { height: to + 'px' }], {
      duration: 185,
      easing: open ? 'cubic-bezier(0, 0, .2, 1)' : 'cubic-bezier(.4, 0, .2, 1)'
    });
    slide = anim;
    anim.onfinish = function () {
      if (slide !== anim) return;
      slide = null;
      panel.style.clipPath = '';
      if (!open) panel.hidden = true;
    };
  }

  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      slidePanel(!open);
    });
    panel.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-rf-value]');
      if (pill && !pill.disabled) {
        pill.setAttribute('aria-pressed', pill.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        paintClears();
        apply();
        return;
      }
      var clear = e.target.closest('[data-rf-clear]');
      if (clear) {
        var g = clear.getAttribute('data-rf-clear');
        Array.prototype.forEach.call(panel.querySelectorAll('[data-rf-group="' + g + '"][aria-pressed="true"]'), function (b) { b.setAttribute('aria-pressed', 'false'); });
        paintClears();
        apply();
        var first = panel.querySelector('[data-rf-group="' + g + '"]:not(:disabled)');
        if (first) first.focus();
      }
    });
  }

  /* The reference fetches every page, so a second click lands while the first
     is still loading and is ignored. Pages here can come from memory; a short
     beat after each one gives an accidental double click the same outcome. */
  var beat = false;
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      if (beat || moreBtn.getAttribute('aria-busy') === 'true') return;
      beat = true;
      window.setTimeout(function () { beat = false; }, 350);
      if (errorBox) errorBox.hidden = true;
      if (view) { appendPage(); return; }
      busy(true);
      load().then(function (reviews) {
        view = reviews;                                // unfiltered: the seeded five are its first five
        appendPage();
        busy(false);
      }).catch(fail);
    });
  }

  /* ---- Yorum ozeti: "Devamini oku" -------------------------------------
     The reference clamps its summary to three lines and offers a Read More.
     The control is drawn ONLY when the text is really cut off — a summary that
     already fits gets no button, which is what the reference does on the
     products whose summary is short. Measured: clamp 3 x 22.4px = 67px. */
  (function () {
    var sum = root.querySelector('[data-sk-revsum]');
    if (!sum) return;
    var text = sum.querySelector('[data-sk-revsum-text]');
    var btn = sum.querySelector('[data-sk-revsum-more]');
    if (!text || !btn) return;
    var moreLabel = btn.textContent.trim();
    var lessLabel = btn.getAttribute('data-less') || moreLabel;

    function sync() {
      if (sum.classList.contains('is-open')) return;
      btn.hidden = text.scrollHeight <= text.clientHeight + 1;
    }
    sync();
    window.addEventListener('resize', sync);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);

    btn.addEventListener('click', function () {
      var open = sum.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? lessLabel : moreLabel;
      if (!open) sync();
    });
  })();

  /* ---- Review photo lightbox -------------------------------------------
     The reference opens a centred 1000x738 white panel holding the photo at
     600x600 object-fit:contain with the review beside it. Delegated, so cards
     paged in later are covered too. No record in this dataset carries a photo
     yet; the shell is here for the day one does. */
  (function () {
    var box = document.querySelector('[data-sk-revlightbox]');
    if (!box) return;
    var img = box.querySelector('[data-sk-revlightbox-img]');
    var cap = box.querySelector('[data-sk-revlightbox-cap]');
    var last = null;

    function open(btn) {
      last = btn;
      img.src = btn.getAttribute('data-full');
      img.alt = btn.getAttribute('data-alt') || '';
      var card = btn.closest('.sk-review');
      if (cap) cap.textContent = card ? (card.querySelector('.sk-review__text') || {}).textContent || '' : '';
      if (typeof box.showModal === 'function') box.showModal(); else box.setAttribute('open', '');
    }
    function close() {
      if (typeof box.close === 'function') box.close(); else box.removeAttribute('open');
      img.removeAttribute('src');
      if (last) { last.focus(); last = null; }
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-sk-revphoto]') : null;
      if (btn) { e.preventDefault(); open(btn); }
    });
    box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('[data-sk-revlightbox-close]')) close(); });
    box.addEventListener('cancel', function () { img.removeAttribute('src'); });
  })();
})();
